import {
  GraphQLNonNull,
  GraphQLInputObjectType,
  GraphQLList,
  GraphQLString,
  GraphQLID,
  GraphQLObjectType,
  GraphQLBoolean
} from 'graphql'
import {
  VulnerabilityFilterArg,
  vulnerabilityFilterArgType
} from './vulnerability-filter-arg'

export interface AdminApprovalEvaluateTracesQueryArgs {
  readonly input?: {
    readonly organizationID: string
    readonly traces: string[]
    readonly status: string
  }
}

export interface AdminApprovalEvaluateTracesByFiltersQueryArgs {
  readonly input?: {
    readonly organizationID: string
    readonly filters: VulnerabilityFilterArg
    readonly status: string
  }
}

export const adminApprovalEvaluateTracesQueryArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'AdminApprovalEvaluateTracesQueryArgs',
      description:
        'Query input type for determining if the specified vulnerabilities are candidates for approval workflow or not.',
      fields: () => ({
        organizationID: {
          description:
            'The ID of the organization that owns the traces being evaluated.',
          type: new GraphQLNonNull(GraphQLID)
        },
        traces: {
          description: 'Vulnerability IDs',
          type: new GraphQLNonNull(
            new GraphQLList(new GraphQLNonNull(GraphQLID))
          )
        },
        status: {
          description: 'Vulnerability status',
          type: new GraphQLNonNull(GraphQLString)
        }
      })
    })
  }
}

export const adminApprovalEvaluateTracesByFiltersQueryArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'AdminApprovalEvaluateTracesByFiltersQueryArgs',
      description:
        'Query input type for determining if the vulnerabilities specified by filters are candidates for approval workflow or not.',
      fields: () => ({
        organizationID: {
          description:
            'The ID of the organization that owns the traces being evaluated.',
          type: new GraphQLNonNull(GraphQLID)
        },
        filters: {
          description: 'Filters describing the traces to be evaluated',
          type: new GraphQLNonNull(vulnerabilityFilterArgType)
        },
        status: {
          description: 'Vulnerability status',
          type: new GraphQLNonNull(GraphQLString)
        }
      })
    })
  }
}

export const adminApprovalEvaluateTracesType = new GraphQLObjectType({
  name: 'AdminApprovalEvaluateTraces',
  fields: () => ({
    result: {
      description:
        'Whether any of the vulnerabilities evaluated are candidate for approval workflow or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    }
  })
})
